module.exports = __webpack_public_path__ + "ATS/img/ic-排名第1.8128c35a.svg";